<template>

  <div>

    <tickets-table
      :status="status"
      :priority="priority"

      title-heading="h2"
      :owner-id="ownerId"

      :bottom-comp="bComp"
      :bottom-comp-props="bCompProps"

      />

  </div>

</template>



<script>

import DashText from '@/components/atoms/DashText'

import TicketStats from '@/components/maintenance/TicketStats'
import TicketsTable from '@/components/tables/TicketsTable'

export default {

  components: {
    DashText,
    TicketsTable
  },

  watch: {

    '$route.params': {
      handler: function (p) {

        if (p.status) {
          this.status = p.status
        } else {
          this.status = null
        }

        if (p.priority) {
          this.priority = p.priority
        } else {
          this.priority = null
        }

        if (p.ownerId) {
          this.ownerId = (!this.isTowerCo() ? this.org().id : Number(p.ownerId))
        }

        this.stats = this.getStats()
      },
      deep: true,
      immediate: true
    },

    stats: function (s) {
      this.stats = s
    }

  },

  data () {

    return {
      media: {xs: 24, sm: 12, md: 6, lg: 3},
      pos: 'center',
      iconSize: '1.5em',
      height: '0.8em',
      bComp: TicketStats,
      bCompProps: {stats: null},
      status: null,
      priority: null,
      ownerId: (this.isTelco() ? this.org().id : null),
      stats: null
    }

  },

  created () {
    this.stats = this.getStats(this.org().id, true)
    this.bCompProps.stats = this.stats
  },

  mounted () {
    let p = this.$route.params

    if (p.status) {
      this.status = p.status
    }

    if (p.priority) {
      this.priority = p.priority
    }

  }

}
</script>



// WEBPACK FOOTER //
// MaintenanceView.vue?20dfc8c2